import { Grid, Box, Typography, Avatar } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { add, isDate, format } from "date-fns";
import { isMobile } from "react-device-detect";
import qs from "qs";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import { getData, storeData, clearData } from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import { Wrapper } from "../../components/NDID2";
import GlobalApi from "../../utils/GlobalApi";
import NDID_ICON from "../../assets/image/ndid_icon.png";
import BANK_ICON from "../../assets/image/bank_app_icon.png";
import DAOL_ICON from "../../assets/image/daol_icon.png";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent"; 
const statusArr = {
  LOADING: ["LOADING", "LOADING"],
  CREATED: [
    "รอผลการยืนยันจากผู้ให้บริการ NDID",
    "รอผลการยืนยันจากผู้ให้บริการ NDID",
  ],
  PENDING: [
    "รอผลการยืนยันจากผู้ให้บริการ NDID",
    "รอผลการยืนยันจากผู้ให้บริการ NDID",
  ],
  ACCEPTED: ["การยืนยันตัวตนสำเร็จ", "การยืนยันตัวตนสำเร็จ"],
  IDP_OR_AS_ERROR: [
    "เกิดข้อผิดพลาด",
    "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
  ],
  REJECTED: [
    "แจ้งเตือน", //ทำรายการใหม่อีกครั้ง
    "ท่านยกเลิกรายการ หรือไม่ทำรายการ<br>ในเวลาที่กำหนด กรุณาทำรายการใหม่",
  ],
  CANCELLED_USER: [
    "แจ้งเตือน", //ทำรายการใหม่อีกครั้ง
    "ท่านยกเลิกรายการ หรือไม่ทำรายการ<br>ในเวลาที่กำหนด กรุณาทำรายการใหม่",
  ],
  CANCELLED: [
    "แจ้งเตือน", //ทำรายการใหม่อีกครั้ง
    "ท่านยกเลิกรายการ หรือไม่ทำรายการ<br>ในเวลาที่กำหนด กรุณาทำรายการใหม่",
  ],
  REQUESTED_ERROR: [
    "เกิดข้อผิดพลาด",
    "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
  ],
  TIMEOUT: [
    "แจ้งเตือน",
    "ท่านยกเลิกรายการ หรือไม่ทำรายการ<br>ในเวลาที่กำหนด กรุณาทำรายการใหม่",
  ],
};

const NdidWaiting = (props) => {
  const translations = getData("Translations");
  const bank_id = getData("bank_id");
  const [lang, setLang] = useState(getData("lang"));
  const bankAppName = getData("bank_app_name");
  const bankAppImage = getData("bank_app_image");
  const checkuserinfo = getData("checkuserinfo");
//   const [countDown, setCountDown] = useState(getData("countDown"));
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
  );
  const [isMaxQuota, setisMaxQuota] = useState(false);
  // let isMaxQuota = false;
  const [nextStep, setNextStep] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [valueModal, setValueModal] = useState({
    isMax: false,
    imgError: true,
    imgSuccess: false,
    title: "ท่านสามารถเปลี่ยนธนาคารได้ 3 ครั้ง",
    massage: "กรุณาตรวจสอบที่แอปพลิเคชันของธนาคารก่อน ยืนยันการเปลี่ยนธนาคาร",
    btnPrimary: "ดำเนินการต่อที่",
    btnSecondary: "ยืนยันการเปลี่ยนธนาคาร",
  });
  const [status, setStatus] = useState({
    status: "Loading",
    requestId: getData("request_id"),
    transactionRef: getData("transaction_ref"),
    referenceId: getData("reference_id"),
    requestMassage: getData("requestMessage"),
    endDate: getData("endDate"),
    endTime: getData("endTime"),
  });
  const [changeBank,setChangeBank] = useState(false);
  // let changeBank = false;
  let CheckStatusIdPVerify;
  const callCancel = async () => {
    try {
      await GlobalApi.get(
        `${Configs.baseAPIURL03}/form/ndid2/cancel?referenceId=${status.referenceId}`
      )
        .then((res) => {
          const data = res.data;
          if (data.code === "ERROR FROM API") {
            console.error(data.message);
          }
        })
        .catch((er) => {
          console.error(er);
        });

    } catch (error) {
      console.error(error);
    }
  };

  const checkTotalOfNDID = async () => {
    console.log('checkTotalOfNDID');
    const card_id = checkuserinfo?.cardId;
    if (card_id === "" || card_id === null || card_id === undefined) {
      setIsModalError(true);
      setModalErrorTitle("ไม่สามารถทำรายการได้");
      setModalErrorDes("เลขบัตรประชาชนไม่ถูกต้อง");
    } else {
      await GlobalApi.get(
        `${Configs.baseAPIURL03}/form/ndid2/quota?identifier=${card_id}`
      )
        .then((res) => {
          console.log('call api');
          const { limit, total } = res.data.data;
          let eventFromStop = getData("event_from_stop");
          console.log(eventFromStop);
          setIsLoading(false);
          clearDataFromLocalStorage();
          storeData("event_from_stop",eventFromStop);
          console.log(total);
          if (total < limit) {
            // storeData("isMaxQuota",false);
            setisMaxQuota(false);
            // isMaxQuota = false;
            props.history.push("/ndid_list");
          }else {
            // props.history.push("/ndid_information");
            // storeData("isMaxQuota",true);
            setisMaxQuota(true);
            // isMaxQuota = true;
            setValueModal({
              isMax: true,
              imgError: true,
              imgSuccess: false,
              title: "ไม่สามารถดำเนินการต่อได้",
              massage:
                "ท่านทำรายการเกินกว่าจำนวนที่บริษัทกำหนด<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
              btnPrimary: "ตกลง",
            });
            setIsModal(true);
            // if(!val)
            // {
            //   if(!eventFromStop){
            //     console.log('แสดง popup ก่อน');
            //     setIsModal(true);
            //     // console.log('jump to information');
            //     // props.history.push("/ndid_information");
            //   }
            //   else{
            //     console.log('ตรวจเสร็จ ไม่ทำอะไร ');
            //     setIsModal(false);
            //   }
            //   // setIsModal(true);
            // }else{
            //   if(!eventFromStop){
            //     console.log('ตรวจเสร็จ ไม่ทำอะไร 1');
            //     setIsModal(false);
            //   }
            //   else{
            //     console.log('แสดง popup ก่อน 1');
            //     setIsModal(true);
            //     // console.log('jump to information1');
            //     // props.history.push("/ndid_information");
            // }
            //   }
          }
        })
        .catch((er) => {
          setModalErrorTitle("เกิดข้อผิดพลาด");
          setModalErrorDes("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง");
          setIsModalError(true);
        });
    }
  };

  const popUps = async (val, statusError, statusSuccess) => {
    // val -> True is primary button : False is secondary button
    console.log(' popUps');
    console.log(val);
    console.log(statusError);
    console.log(statusSuccess);
    console.log("isMaxQuota" , isMaxQuota);
    console.log();
    console.log("Change bank ", changeBank);
    
    if (statusSuccess) {
      props.history.goBack();
    } else{
      if(isMaxQuota) {
        props.history.push("/ndid_information");
      }
       else if(changeBank && val){
        setChangeBank(false);
      }
      else{
        await checkTotalOfNDID();
      }
    }
    
    
    // else if (val && statusError) {
    //   // Decline(true, true) change bank -> push to NdidList.js
    //   if(getData("event_from_stop"))
    //   {
    //     console.log("กลับ flag");
    //     console.log(getData("event_from_stop"));
    //     await checkTotalOfNDID(!val,statusError);
    //   }
    //   else{
    //     console.log("switchType");
    //     console.log(getData("event_from_stop"));
    //     await checkTotalOfNDID(val,statusError);
    //   }
    //   // await checkTotalOfNDID(val,statusError);
      

    // } else if (!val && statusError) {
    //   // Confirm(false, true) change bank -> push to NdidList.js
    //   if(getData("event_from_stop"))
    //   {
    //     console.log("กลับ flag1");
    //     console.log(getData("event_from_stop"));
    //     await checkTotalOfNDID(!val,statusError);
    //   }
    //   else{
    //     console.log("switchType1");
    //     console.log(getData("event_from_stop"));
    //     await checkTotalOfNDID(val,statusError);
    //   }
      
      // await checkTotalOfNDID(val,statusError);
    //}
  };

  const handleNext = async () => {
    clearInterval(CheckStatusIdPVerify);
    window.clearInterval(CheckStatusIdPVerify);
    console.log('เปลี่ยนธนาคารได้ 2 ครั้ง');
    storeData("event_from_stop",false);
    setChangeBank(true);
    // changeBank = true;
    setValueModal({
      imgError: true,
      imgSuccess: false,
      title: "ท่านสามารถเปลี่ยนธนาคารได้ 2 ครั้ง",
      massage: "กรุณาตรวจสอบที่แอปพลิเคชันของธนาคารก่อนยืนยันการเปลี่ยนธนาคาร",
      btnPrimary: "ดำเนินการต่อที่ " + bankAppName,
      btnSecondary: "ยืนยันการเปลี่ยนธนาคาร",
    });
    setIsModal(true);
  };

  const check_status = async (NDIDRequestId, ReferenceId, TransactionRef, RequestMessage, EndDate, EndTime) => {
    setStatus({
      ...status,
      requestId: NDIDRequestId,
      referenceId: ReferenceId,
      transactionRef: TransactionRef,
      requestMassage: RequestMessage,
      endDate: EndDate,
      endTime: EndTime,
    });
    CheckStatusIdPVerify = setInterval(async function () {
      await GlobalApi.get(`${Configs.baseAPIURL03}/form/ndid2/check`, {
        params: {
          referenceId: ReferenceId,
        },
      })
        .then(async (res) => {
          const NDID_Status = res.data.data.data.Status.toUpperCase();
          const ErrorMessage = res.data.data.data.ErrorMessage
            ? res.data.data.data.ErrorMessage
            : "";
          if (NDID_Status === "CANCELLED") {
            if (res.data.data.data.cancelled_by_user) {
              setStatus({
                ...status,
                status: NDID_Status,
                requestId: NDIDRequestId,
                referenceId: ReferenceId,
                transactionRef: TransactionRef,
                requestMassage: RequestMessage,
                statusDisplay: statusArr["CANCELLED_USER"][1],
                errorMassage: ErrorMessage,
                endDate: EndDate,
                endTime: EndTime,
              });
            } else {
              setStatus({
                ...status,
                status: NDID_Status,
                requestId: NDIDRequestId,
                referenceId: ReferenceId,
                transactionRef: TransactionRef,
                requestMassage: RequestMessage,
                statusDisplay: statusArr["CANCELLED"][1],
                errorMassage: ErrorMessage,
                endDate: EndDate,
                endTime: EndTime,
              });
            }
          } else {
            setStatus({
              ...status,
              status: NDID_Status,
              requestId: NDIDRequestId,
              referenceId: ReferenceId,
              transactionRef: TransactionRef,
              requestMassage: RequestMessage,
              statusDisplay: statusArr[NDID_Status][1],
              endDate: EndDate,
              endTime: EndTime,
            });
          }
          if (
            NDID_Status === "ACCEPTED" ||
            NDID_Status === "CANCELLED" ||
            NDID_Status === "IDP_OR_AS_ERROR" ||
            NDID_Status === "REJECTED" ||
            NDID_Status === "REQUESTED_ERROR" ||
            NDID_Status === "TIMEOUT"
          ) {
            clearInterval(CheckStatusIdPVerify);
            stop(NDID_Status);
          }
        })
        .catch((error) => {
          const api_error = getData("api_error")?.data;
          if (api_error.MsgDesc && api_error.MsgDesc?.message) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error.MsgDesc?.message);
          } else if (api_error?.MsgDesc) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error?.MsgDesc);
          } else {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง");
          }
          setIsModalError(true);
          return clearInterval(CheckStatusIdPVerify);
        });
    }, 5000);
  };

  const stop = (s) => {
    console.log("stop");
    console.log(s);
    storeData("event_from_stop",true);
    setChangeBank(false);
    // changeBank = false;
    if (s === "ACCEPTED") {
      storeData("pass_ndid", true);
      setValueModal({
        imgError: false,
        imgSuccess: true,
        title: statusArr[s][0],
        btnPrimary: "ถัดไป",
      });
    } else if (s === "CANCELLED" || s === "REJECTED") {
      setValueModal({
        imgError: true,
        imgSuccess: false,
        title: statusArr[s][0],
        massage: statusArr[s][1],
        btnPrimary: "ตกลง",
      });
    } else if (s === "TIMEOUT") {
      setValueModal({
        imgError: true,
        imgSuccess: false,
        title: statusArr[s][0],
        massage: statusArr[s][1],
        btnPrimary: "ตกลง",
      });
    } else if (s === "REQUESTED_ERROR" || s === "IDP_OR_AS_ERROR") {
      setValueModal({
        imgError: true,
        imgSuccess: false,
        title: statusArr[s][0],
        massage: statusArr[s][1],
        btnPrimary: "ตกลง",
      });
    } else {
      setValueModal({
        imgError: true,
        imgSuccess: false,
        title: "เกิดข้อผิดพลาด",
        massage: "ไม่สามารถทำรายการได้ในขณะนี้ กรุณาทำรายการใหม่",
        btnPrimary: "ตกลง",
      });
    }

    setIsModal(true);
  };

  const callStatus = async () => {
    setIsLoading(true);
    try {
      const idc = getData("idc");
      const HeaderManp = getData("HeaderManp");

      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/ndid2/verify`,
        undefined,
        {
          params: {
            identifier: idc?.idCard,
            listIdp: bank_id,
            consentNdid: true,
            token: HeaderManp?.token,
          },
        }
      )
        .then(async (res) => {
          setIsLoading(false);
          const data = res.data.data.data[0];
          const initCountDown = add(new Date(), { hours: 1 });
          const endDate = format(initCountDown, "dd/MM/yyyy");
          const endTime = format(initCountDown, "HH:mm");

          storeData("reference_id", data.ReferenceId);
          storeData("transaction_ref", data.TransactionRef);
          storeData("request_id", data.NDIDRequestId);
          storeData("requestMessage", data.RequestMessage);
          storeData("endDate", endDate);
          storeData("endTime", endTime);
          await check_status(
            data.NDIDRequestId,
            data.ReferenceId,
            data.TransactionRef,
            data.RequestMessage,
            endDate,
            endTime,
          );
          if (res.data.data.IsSuccess) {
            storeData("reference_id", data.ReferenceId);
            storeData("transaction_ref", data.TransactionRef);
          } else {
            clearInterval(CheckStatusIdPVerify);
            if (res.data.code === "error limit") {
              clearDataFromLocalStorage();
              setValueModal({
                isMax: true,
                imgError: true,
                imgSuccess: false,
                title: "ไม่สามารถดำเนินการต่อได้",
                massage:
                  "เนื่องจากท่านทำรายการเปลี่ยนธนาคาร<br/>เกินกว่าจำนวนที่บริษัทกำหนด<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
                btnPrimary: "ตกลง",
              });
              setIsModal(true);
            } else {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(res?.data?.message);
              setIsModalError(true);
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
          const api_error = getData("api_error")?.data;
          if (api_error.MsgDesc && api_error.MsgDesc?.message) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error.MsgDesc?.message);
          } else if (api_error?.MsgDesc) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error?.MsgDesc);
          } else {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(
              "สอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ DAOL Contact Center<br>0 2351 1800"
            );
          }
          clearInterval(CheckStatusIdPVerify);
          setIsModalError(true);
        });
    } catch (er) {
      // console.log(er);
      setIsLoading(false);
      setModalErrorTitle("เกิดข้อผิดพลาด");
      setModalErrorDes(er);
      setIsModalError(true);
      clearInterval(CheckStatusIdPVerify);
    }
  };

  const clearDataFromLocalStorage = () => {
    clearData("requestMessage");
    clearData("event_from_stop");
    clearData("request_id");
    clearData("reference_id");
    clearData("transaction_ref");
    clearData("pass_ndid");
    clearData("endDate");
    clearData("endTime");
    // clearData("countDown");
  };

  useEffect(() => {
    const ReferenceId = getData("reference_id") || "";
    const TransactionRef = getData("transaction_ref") || "";
    const NDIDRequestId = getData("request_id") || "";
    const RequestMessage = getData("requestMessage") || "";
    const EndDate = getData("endDate") || "";
    const EndTime = getData("endTime") || "";
    console.log(`${EndDate}:${EndTime}`);
    console.log(TransactionRef);
    if (isEmpty(TransactionRef)) {
      callStatus();
    } else {
      check_status(NDIDRequestId, ReferenceId, TransactionRef, RequestMessage, EndDate, EndTime);
    }

    return () => {
      callCancel();
      clearInterval(CheckStatusIdPVerify);
    };
  }, []);
  return (
    <>
      <HeaderPage
        title="ยืนยันตัวตนทางดิจิทัล (NDID)"
        onChangeLang={(e) => setLang(e)}
        comeback
      />
      <Loading status={isLoading} />
      <DialogCustoms
        imgModalError={valueModal.imgError}
        open={isModalError}
        isModel={setIsModalError}
        title={modalErrorTitle}
        massage={modalErrorDes}
        btnPrimary={"ตกลง"}
      />
      <DialogCustoms
        open={isModal}
        isModel={setIsModal}
        imgModalError={valueModal.imgError}
        imgModalSuccess={valueModal.imgSuccess}
        switchType={(e) => {
          popUps(e, valueModal.imgError, valueModal.imgSuccess);
        }}
        title={valueModal.title}
        massage={valueModal.massage}
        btnPrimary={valueModal.btnPrimary}
        btnSecondary={valueModal.btnSecondary}
      />
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent
                    translations={translations?.[lang]?.ndid}
                    ndid_list
                  />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 16 : 9}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid
                    className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            px:2
                          }}
                  >
                    {!isMobile && (
                      <HeaderRight ndid title="ยืนยันตัวตนทางดิจิทัล (NDID)" />
                    )}
                 
                      <Grid>
                        <Typography
                          className="font-DBHeavent text-primary"
                          sx={{
                            fontFamily: "DB Heavent Med !important",
                            fontSize: "22px",
                            lineHeight: "26px",
                            textAlign: "center",
                            pt:3
                          }}
                        >
                          กรุณายืนยันตัวตนทางดิจิทัล NDID ภายใน
                        </Typography>
                      </Grid>
                      {status?.endDate && status?.endTime && (
                        <Grid
                          sx={{
                            padding: "9px",
                            borderRadius: "10px",
                            backgroundColor: "#F7F8FB",
                            marginTop: "10px",
                            marginBottom: "6px",
                          }}
                        >
                          <Typography
                            className="font-DBHeavent text-primary"
                            sx={{
                              fontSize: "26px",
                              lineHeight: "31px",
                              textAlign: "center",
                            }}
                          >
                            เวลา {status?.endTime} น.
                            <br />
                            วันที่ {status?.endDate}
                          </Typography>
                        </Grid>
                      )}
                      {status?.transactionRef && (
                        <Grid>
                          <Typography
                            className="font-DBHeavent text-primary"
                            sx={{
                              fontSize: "16px",
                              lineHeight: "19px",
                              textAlign: "center",
                            }}
                          >
                            รหัสอ้างอิง : {status?.transactionRef}
                          </Typography>
                        </Grid>
                      )}
                  
                        <ScrollBarComponent
                          content={
                            <Grid id="ndid-steps" container>
                              <Grid
                                sx={{ marginBottom: "16px", width: "100%" }}
                              >
                                <Typography
                                  className="text-primary"
                                  sx={{
                                    fontFamily: "DB Heavent Med !important",
                                    fontSize: "22px",
                                    lineHeight: "26px",
                                    textAlign: "center",
                                  }}
                                >
                                  ขั้นตอนการยืนยันตัวตน
                                </Typography>
                              </Grid>
                              {/* ------- NDID Step 1 -------  */}
                              <Box
                                id="ndid-step-1"
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              >
                                <Box
                                  id="step-img"
                                  sx={{
                                    marginRight: "16px",
                                    padding: "11px",
                                    backgroundColor: "#F7F8FB",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <Avatar
                                    alt={bankAppName}
                                    src={bankAppImage}
                                    variant="rounded"
                                    sx={{ width: 48, height: 48 }}
                                  />
                                </Box>
                                <Box id="step-description">
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-18 text-primary"
                                      sx={{ lineHeight: "22px" }}
                                    >
                                      ขั้นตอนที่ 1
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-20 text-black"
                                      sx={{ lineHeight: "24px" }}
                                    >
                                      กรุณาเปิดแอปพลิเคชัน{" "}
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          color: "#AA875E",
                                          lineHeight: "24px",
                                        }}
                                        variant="span"
                                      >
                                        {bankAppName}
                                      </Typography>{" "}
                                      เพื่อยืนยันตัวตน
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              {/* ------- NDID Step 2 -------  */}
                              <Box
                                id="ndid-step-2"
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              >
                                <Box
                                  id="step-img"
                                  sx={{
                                    marginRight: "16px",
                                    padding: "11px",
                                    backgroundColor: "#F7F8FB",
                                    borderRadius: "10px",
                                    width: "48px",
                                    height: "48px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    alt="ndid-logo"
                                    src={NDID_ICON}
                                    variant="rounded"
                                    sx={{ width: 48, height: 26 }}
                                  />
                                </Box>
                                <Box id="step-description">
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-18 text-primary"
                                      sx={{ lineHeight: "22px" }}
                                    >
                                      ขั้นตอนที่ 2
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-20 text-black"
                                      sx={{ lineHeight: "24px" }}
                                    >
                                      เลือก{" "}
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          color: "#AA875E",
                                          lineHeight: "24px",
                                        }}
                                        variant="span"
                                      >
                                        “บริการ NDID”
                                      </Typography>{" "}
                                      เพื่อยืนยันตัวตน
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              {/* ------- NDID Step 3 -------  */}
                              <Box
                                id="ndid-step-3"
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "20px",
                                }}
                              >
                                <Box
                                  id="step-img"
                                  sx={{
                                    marginRight: "16px",
                                    padding: "11px",
                                    backgroundColor: "#F7F8FB",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    alt="bank-icon"
                                    src={BANK_ICON}
                                    variant="rounded"
                                    sx={{ width: 48, height: 48 }}
                                  />
                                </Box>
                                <Box id="step-description">
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-18 text-primary"
                                      sx={{ lineHeight: "22px" }}
                                    >
                                      ขั้นตอนที่ 3
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-20 text-black"
                                      sx={{ lineHeight: "24px" }}
                                    >
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          color: "#AA875E",
                                          lineHeight: "24px",
                                        }}
                                        variant="span"
                                      >
                                        ทำตามขั้นตอน
                                      </Typography>{" "}
                                      ในแอปพลิเคชันของธนาคารจนเสร็จสิ้น
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              {/* ------- NDID Step 4 -------  */}
                              <Box
                                id="ndid-step-4"
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <Box
                                  id="step-img"
                                  sx={{
                                    marginRight: "16px",
                                    padding: "11px",
                                    backgroundColor: "#F7F8FB",
                                    borderRadius: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    width: "48px",
                                    height: "48px",
                                  }}
                                >
                                  <Avatar
                                    alt="daolife-icon"
                                    src={DAOL_ICON}
                                    variant="rounded"
                                    sx={{ width: 48, height: 12 }}
                                  />
                                </Box>
                                <Box id="step-description">
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-18 text-primary"
                                      sx={{ lineHeight: "22px" }}
                                    >
                                      ขั้นตอนที่ 4
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      className="font-DBHeavent font-20 text-black"
                                      sx={{ lineHeight: "24px" }}
                                    >
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          color: "#AA875E",
                                          lineHeight: "24px",
                                        }}
                                        variant="span"
                                      >
                                        กลับมายัง
                                      </Typography>{" "}
                                      ระบบเปิดบัญชี DAOL SEC เพื่อดำเนินการต่อ
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          }
                        />
               
                    <ButtonRight
                      hide={status.status === "Loading" ? true : false}
                      BtnSecondary
                      text={translations?.[lang]?.ndid?.next_waiting}
                      onNextPage={handleNext}
                      btnStyle={{
                        transform: "unset",
                        top: "0",
                        height: "47px !important",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );};

export default memo(NdidWaiting);
